export enum MediaType {
    VIDEO = 'video',
    SCREENSHOT = 'screenshot',
    THUMBNAIL = 'thumbnail',
    WIDE_THUMBNAIL = 'widethumbnail',
    MAP_BACKGROUND = 'mapbackground',
    MAP_LOCATION = 'maplocation',
    UNKNOWN = 'unknown',
    TAB_THUMBNAIL = 'tabthumbnail',
    TAB_BACKGROUND = 'tabbackground',
    TAB_ICON = 'tabicon',
    TAG_ICON = 'tag_icon',
    IAP_IMAGE = 'iapimage',
    IAE_CARD = 'iaecard',
    IAE_DETAILS_PAGE = 'iaedetailspage',
    BANNER_MOON_BACKGROUND = 'banner_moon_background',
    BANNER_PORTRAIT_LARGE_BACKGROUND = 'banner_portrait_large_background',
    BANNER_LANDSCAPE_TOP_PANEL_BACKGROUND = 'banner_landscape_top_panel_background',
    BANNER_LANDSCAPE_SPEECH_BUBBLE_BACKGROUND = 'banner_landscape_speech_bubble_background',
    BANNER_LANDSCAPE_WITH_BUTTON_BACKGROUND = 'banner_landscape_with_button_background',
    BANNER_LANDSCAPE_WIDE_BACKGROUND = 'banner_landscape_wide_background',
    BANNER_RECTANGULAR_MEDIUM_BACKGROUND = 'banner_rectangular_medium_background',
    PORTAL = 'portal',
    PACK_DRAWER_THUMB = 'pack_drawer_thumb',
}

export type MediaTypeUnion = `${MediaType}`;

export type ShopTabMediaTypes = MediaType.TAB_BACKGROUND | MediaType.TAB_ICON;

export type BannerMediaTypes =
    | MediaType.BANNER_MOON_BACKGROUND
    | MediaType.BANNER_PORTRAIT_LARGE_BACKGROUND
    | MediaType.BANNER_LANDSCAPE_TOP_PANEL_BACKGROUND
    | MediaType.BANNER_LANDSCAPE_SPEECH_BUBBLE_BACKGROUND
    | MediaType.BANNER_LANDSCAPE_WITH_BUTTON_BACKGROUND
    | MediaType.BANNER_LANDSCAPE_WIDE_BACKGROUND
    | MediaType.BANNER_RECTANGULAR_MEDIUM_BACKGROUND;
